// extracted by mini-css-extract-plugin
export default {"projectDetails":"style_projectDetails__puoBb","title":"style_title__vAvM2","container":"style_container__eYxys"};